import React from 'react';
import { Button, Box } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { generateCSV, downloadCSV } from '../utils/csvUtils';

/**
 * ExportButtons component for CSV export functionality
 */
const ExportButtons = ({ tableData, filteredData }) => {
  // Handler for exporting all data
  const handleExportAll = () => {
    const csvContent = generateCSV(tableData);
    downloadCSV(csvContent, 'all_transactions.csv');
  };

  // Handler for exporting filtered data
  const handleExportFiltered = () => {
    const csvContent = generateCSV(filteredData);
    downloadCSV(csvContent, 'filtered_transactions.csv');
  };

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Button
        variant="contained"
        startIcon={<FileDownloadIcon />}
        onClick={handleExportAll}
      >
        Export to CSV
      </Button>
      <Button
        variant="contained"
        startIcon={<FileDownloadIcon />}
        onClick={handleExportFiltered}
      >
        Export Filtered to CSV
      </Button>
    </Box>
  );
};

export default ExportButtons;